import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

class ProjectViewModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
    }

    // OTHER METHODS

    isProjectMine = (projectName) => {
        for (let i = 0; i < this.props.projectNames.length; i++) {
            if (this.props.projectNames[i] === projectName) {
                return true;
            }
        }
        return false;
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} onRequestHide={this.handleClose} className="modal fade" id="myModal3" tabIndex="-1" role="dialog" aria-labelledby="myModal3Label" aria-hidden="true">
                <div className="popover1 popover2 modal-dialog new-log-entry">
                    <div className="modal-content">
                        <form>
                            <div className="head modal-header">
                                <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                                <h2 className="modal-title">{this.props.usersName}</h2>
                            </div>
                            <div className="scrollable-div content modal-body">
                              <h6>Week #{this.props.date.isoWeek()}<br/>{this.props.date.format("DD.MM.YYYY.")}-{this.props.date.clone().add(6,'days').format("DD.MM.YYYY.")}</h6>
                              <table className="table table-condensed">
                                        <tbody>
                                            {
                                                this.props.taskKeys.map((taskID, key) => {
                                                    let logEntry = this.props.tasks[taskID]; //task = logEntry
                                                    let projectHours = this.props.projectHours[logEntry.projectID];
                                                    let projectName = logEntry.projectName;

                                                    let regularHours = logEntry.regularHours;
                                                    let regularMinutes = logEntry.regularMinutes;
                                                    let overtimeHours = logEntry.overtimeHours;
                                                    let overtimeMinutes = logEntry.overtimeMinutes;
                                                    
                                                    let projectRegularHours = projectHours.regularHours;
                                                    let projectRegularMinutes = projectHours.regularMinutes;
                                                    let projectOvertimeHours = projectHours.overtimeHours;
                                                    let projectOvertimeMinutes = projectHours.overtimeMinutes;

                                                    return (
                                                        <tr key={key} className={this.isProjectMine(projectName) ? "my-projects" : ""}>
                                                            <td style={{"maxWidth" : "150px", "borderLeft" : "5px solid " + logEntry.color}}>
                                                                <span style={{"fontSize" : "12px"}}>
                                                                    {projectName}&nbsp;&nbsp;({projectRegularHours + "h " + projectRegularMinutes + "min"}
                                                                    <span style={{"color" : "red"}}>
                                                                        {projectOvertimeHours > 0 || projectOvertimeMinutes > 0 ? " + " + projectOvertimeHours + ":" + projectOvertimeMinutes: ""}
                                                                    </span>
                                                                    <span style={projectOvertimeHours > 0 || projectOvertimeMinutes > 0 ? {"color" : "red"} : {}}>
                                                                    </span>)
                                                                </span>
                                                                <br/>
                                                                <span style={{"fontSize" : "12px"}}>{logEntry.taskName}</span>
                                                            </td>
                                                            <td><span style={{"color" : "#888"}}>{regularHours + "h"}{regularMinutes > 0 ? " " + regularMinutes + "min" : ""}<br/><span className="mock" style={overtimeHours > 0 || overtimeMinutes > 0 ? {"color" : "red"} : {}}>{overtimeHours > 0 || overtimeMinutes > 0 ? overtimeHours + "h" : ""}{overtimeMinutes > 0 ? " " + overtimeMinutes + "min" : ""}</span> </span></td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                              </table>
                            </div>
                            <div className="modal-footer">
                                <button title="Close user work details by tasks" type="button" className="btn btn-default btn-large" onClick={this.handleClose}>Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        );
    }
}

ProjectViewModal.propTypes = {
    color: PropTypes.string,
    date: PropTypes.object,
    handleClose: PropTypes.func,
    logEntriesByTimesheet: PropTypes.object,
    projectHours: PropTypes.object,
    projectNames: PropTypes.array,
    projectName: PropTypes.string,
    shouldApprove: PropTypes.bool,
    taskKeys: PropTypes.array,
    tasks: PropTypes.object,
    usersName: PropTypes.string
};

ProjectViewModal.defaultProps = {
    projectHours: {},
    taskKeys: [],
    tasks: {}
};

const mapStateToProps = (state) => {
    let logEntriesByTimesheetTasks = state.logEntries.logEntriesByTimesheetTasks;
    return {
        projectHours: logEntriesByTimesheetTasks.projectHours,
        taskKeys: logEntriesByTimesheetTasks.taskKeys,
        tasks: logEntriesByTimesheetTasks.tasks
    };
};

export default connect(
    mapStateToProps
)(ProjectViewModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/ProjectViewModal.js
 **/